import {Component, computed, inject, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {TooltipModule} from 'primeng/tooltip';
import {TranslocoService} from '@jsverse/transloco';
import {DirectusService, Tooltip} from '@frontend/directus';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {of, switchMap} from 'rxjs';

@Component({
  selector: 'app-directus-tooltip',
  imports: [NgClass, TooltipModule],
  templateUrl: './directus-tooltip.component.html',
  styleUrls: ['./directus-tooltip.component.scss'],
  host: {'title': ''},
})
export class DirectusTooltipComponent {
  private readonly directusService = inject(DirectusService);
  private readonly transloco = inject(TranslocoService);

  readonly icon = input<string>('pi pi-info-circle');
  readonly tooltipKey = input<string>('');
  readonly tooltip = input<string>();
  readonly tooltipStyleClass = input<string>('tooltip-bg-third-level');
  readonly tooltipPosition = input<string>('right');

  private readonly currentLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  private readonly directusTooltip = toSignal(
    toObservable(this.tooltipKey).pipe(
      switchMap((key) => (key ? this.directusService.loadTooltipByKey(key) : of(null))),
    ),
    {initialValue: null as Tooltip | null},
  );

  readonly tooltipText = computed(() => {
    const translatedTooltip = this.tooltip();
    if (translatedTooltip) return translatedTooltip;

    const data = this.directusTooltip();
    const lang = this.currentLang();
    const match = data?.translations?.find((t) => t.language === lang);
    return match?.tooltipText ?? data?.translations?.[0]?.tooltipText ?? this.tooltipKey();
  });

  readonly tooltipStyleClassValue = computed(
    () => (this.tooltipStyleClass() ? this.tooltipStyleClass() + ' ' : '') + 'directus-tooltip',
  );
}
